"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DCI Lint Core API
 * Contains/describes the core API types for DCI Lint.
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.LintGithubOrgResponseOutcomeEnum = exports.LintGitRepoResponseOutcomeEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
/**
    * @export
    * @enum {string}
    */
var LintGitRepoResponseOutcomeEnum;
(function (LintGitRepoResponseOutcomeEnum) {
    LintGitRepoResponseOutcomeEnum["Success"] = "dci-lint.lint-git-repo-response.outcome.SUCCESS";
    LintGitRepoResponseOutcomeEnum["Inconclusive"] = "dci-lint.lint-git-repo-response.outcome.INCONCLUSIVE";
    LintGitRepoResponseOutcomeEnum["Failure"] = "dci-lint.lint-git-repo-response.outcome.FAILURE";
})(LintGitRepoResponseOutcomeEnum = exports.LintGitRepoResponseOutcomeEnum || (exports.LintGitRepoResponseOutcomeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var LintGithubOrgResponseOutcomeEnum;
(function (LintGithubOrgResponseOutcomeEnum) {
    LintGithubOrgResponseOutcomeEnum["Success"] = "dci-lint.lint-github-org-response.outcome.SUCCESS";
    LintGithubOrgResponseOutcomeEnum["Inconclusive"] = "dci-lint.lint-github-org-response.outcome.INCONCLUSIVE";
    LintGithubOrgResponseOutcomeEnum["Failure"] = "dci-lint.lint-github-org-response.outcome.FAILURE";
})(LintGithubOrgResponseOutcomeEnum = exports.LintGithubOrgResponseOutcomeEnum || (exports.LintGithubOrgResponseOutcomeEnum = {}));
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Lints a Git repository
         * @param {LintGitRepoRequest} [lintGitRepoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lintGitRepoV1: async (lintGitRepoRequest, options = {}) => {
            const localVarPath = `/api/v1/lint-git-repo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(lintGitRepoRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Lints a Github organization
         * @param {LintGithubOrgRequest} [lintGithubOrgRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lintGithubOrgV1: async (lintGithubOrgRequest, options = {}) => {
            const localVarPath = `/api/v1/lint-github-org`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(lintGithubOrgRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Lints a Git repository
         * @param {LintGitRepoRequest} [lintGitRepoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lintGitRepoV1(lintGitRepoRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lintGitRepoV1(lintGitRepoRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @summary Lints a Github organization
         * @param {LintGithubOrgRequest} [lintGithubOrgRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lintGithubOrgV1(lintGithubOrgRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lintGithubOrgV1(lintGithubOrgRequest, options);
            return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary Lints a Git repository
         * @param {LintGitRepoRequest} [lintGitRepoRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lintGitRepoV1(lintGitRepoRequest, options) {
            return localVarFp.lintGitRepoV1(lintGitRepoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Lints a Github organization
         * @param {LintGithubOrgRequest} [lintGithubOrgRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lintGithubOrgV1(lintGithubOrgRequest, options) {
            return localVarFp.lintGithubOrgV1(lintGithubOrgRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary Lints a Git repository
     * @param {LintGitRepoRequest} [lintGitRepoRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    lintGitRepoV1(lintGitRepoRequest, options) {
        return (0, exports.DefaultApiFp)(this.configuration).lintGitRepoV1(lintGitRepoRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Lints a Github organization
     * @param {LintGithubOrgRequest} [lintGithubOrgRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    lintGithubOrgV1(lintGithubOrgRequest, options) {
        return (0, exports.DefaultApiFp)(this.configuration).lintGithubOrgV1(lintGithubOrgRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=data:application/json;base64,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